// extracted by mini-css-extract-plugin
export default {"empty-list":"Wishlist_empty-list__6jf7t","categoryList":"Wishlist_categoryList__NRMxL","categoryImage":"Wishlist_categoryImage__oj5VA"};